import React from "react";
import type { RouteComponentProps } from "react-router-dom";

import { getRequestStatusValue } from "~/tools/request-status";

import { selectStackPackStatus } from "../../../app/state/entities/stackPacks/StackPacksSelectors";
import { useNavigateToLink } from "../../../components/react/link";
import { useParametricSelector } from "../../../generic/redux/SelectorUtils";
import { STACKPACKS_STACKPACK_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export interface StackPacksDetailBreadcrumbRouteParams {
	name: string;
}

export const StackPacksDetailBreadcrumb = ({ match }: RouteComponentProps<StackPacksDetailBreadcrumbRouteParams>) => {
	const status = useParametricSelector(selectStackPackStatus, match.params.name);
	const stackPack = getRequestStatusValue(status);
	const link = useNavigateToLink(STACKPACKS_STACKPACK_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters", "type"],
		params: { name: match.params.name },
	});

	return stackPack ? <BreadcrumbLayout label={stackPack.displayName} to={link} /> : null;
};

StackPacksDetailBreadcrumb.PATH = STACKPACKS_STACKPACK_PATH;
